'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import leaveSetAction from '../../actions/leaveSetAction';
import leaveSetStore from '../../stores/leaveSetStore';

class LeaveSetFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        
        this.state={
            search: leaveSetStore.getState().search,
        }
    }

    componentDidMount(){
        leaveSetStore.listen(this.onChange);
    }
    componentWillUnmount() {
        leaveSetStore.unlisten(this.onChange);
       
    }
    
    onChange(state){
        this.setState({
            search: state.search
        })
    }
    handleChange(e){
        let search = e.target.value;
        leaveSetAction.search(search);
    }

    handleSubmit(){
        let value = ReactDom.findDOMNode(this.refs.empName).value;
        leaveSetAction.search(value);
        leaveSetAction.updating(false);
    }
    render() {
        return (
            <div className="row atd-i">
                <form className="form-horizontal atd-i-wp">
                    <label htmlFor="empName" className="col-xs-4 control-label">Employee: </label>

                    <div className="input-group">
                        <input type="text" className="form-control" ref="empName" id="empName" placeholder="Search Employee by Name or Id" value={this.state.search} onChange={this.handleChange}/>
                        <span className="input-group-btn">
                            <button className="btn btn-default" type="button" onClick={this.handleSubmit}>Search</button>
                        </span>
                    </div>
                    
                </form>
                
            </div>

        );
    }
}
export default LeaveSetFilter;


// WEBPACK FOOTER //
// ./app/setComponents/leaveSetComponents/leaveSetFilter.js